import { Component, Inject, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  @ViewChild('dynamicContent', { read: ViewContainerRef, static: true })
  dynamicContent!: ViewContainerRef;

    constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalComponent>,
    private cfr: ComponentFactoryResolver
  ) {}

  async ngOnInit() {
    if (this.data?.component) {
      const factory = this.cfr.resolveComponentFactory(this.data.component);
      const componentRef = this.dynamicContent.createComponent(factory);

      // Pass data to dynamic component if provided
      if (this.data?.componentData) {
        Object.assign(componentRef.instance!, this.data.componentData);
      }
    }
  }

  onAction(action: any) {
    if (action.closeOnClick) {
      this.dialogRef.close(action.returnValue || true);
    }
  }

}
